import { CopyButton } from '@/components/ui/CopyButton'
import { PolicyStatus } from '@/models/insurancePolicy'
import { InsurancePolicy } from '../../App/Insurance/InsurancePolicy'
import { Demo, DsSection } from '../primitives'
import { MOCK_CARGO_POLICY, MOCK_POLICY, MOCK_SUMMARY } from './policyCardMocks'

const noop = () => {}

const CANCEL_DATE: Partial<Record<PolicyStatus, string>> = {
  [PolicyStatus.CANCELING]: '2026-11-20',
  [PolicyStatus.CANCELED]: '2026-10-15',
}

function Labeled({ value, children }: { value: string; children: React.ReactNode }) {
  return (
    <div className="flex min-w-0 flex-col gap-2">
      {children}
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{value}</span>
        <CopyButton
          value={value}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function PolicyCardSection() {
  return (
    <DsSection id="policy-card" title="Policy card">
      <Demo label="Customer" className="grid gap-8 xl:grid-cols-2">
        <Labeled value="<InsurancePolicy policy={policy} canViewDocuments />">
          <InsurancePolicy policy={MOCK_POLICY} canViewDocuments />
        </Labeled>
        <Labeled value="canViewDocuments={false}">
          <InsurancePolicy policy={MOCK_CARGO_POLICY} canViewDocuments={false} />
        </Labeled>
      </Demo>

      <Demo label="Status" className="grid gap-8 xl:grid-cols-2">
        {Object.values(PolicyStatus).map((status) => (
          <Labeled key={status} value={`status: PolicyStatus.${status}`}>
            <InsurancePolicy
              policy={{
                ...MOCK_POLICY,
                id: `ds-${status}`,
                status,
                dateCanceled: CANCEL_DATE[status] ?? null,
              }}
              canViewDocuments={false}
            />
          </Labeled>
        ))}
      </Demo>

      <Demo label="Coverage summary" className="grid gap-8 xl:grid-cols-2">
        <Labeled value="summary: string">
          <InsurancePolicy policy={{ ...MOCK_POLICY, summary: MOCK_SUMMARY }} canViewDocuments={false} />
        </Labeled>
      </Demo>

      <Demo label="Staff" consoleOnly className="grid gap-8 xl:grid-cols-2">
        <Labeled value="isStaff onEditPolicy={edit} onCancelPolicy={cancel}">
          <InsurancePolicy
            policy={{
              ...MOCK_POLICY,
              broker: 'Rocklake',
              corgiPolicyLinks: [{ policyNumber: 'CRG-20931', url: '#policy-card' }],
            }}
            canViewDocuments
            isStaff
            onEditPolicy={noop}
            onCancelPolicy={noop}
            onUploadPolicyDoc={noop}
            onGenerateSummary={noop}
          />
        </Labeled>
      </Demo>
    </DsSection>
  )
}
